import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 


const styles = StyleSheet.create({

          table: {
            
            display: 'table',
            width: '70%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '10%', 
          },
          detailsCell: {
            width: '90%', 
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, 
          },
          bulletSymbol: {
            width: 10,
            fontSize: 10,
            marginRight: 5, 
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          

          photoContainer: {
            alignItems: 'center',
            marginVertical: 15,
          },
          photoRectangle: {
            width: 200,
            height: 140,
            borderWidth: 1,
            borderColor: '#000',
            borderStyle: 'solid',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f5f5f5', // Light gray background
          },
          photoText: {
            fontSize: 10,
            color: '#666',
            textAlign: 'center',
            paddingHorizontal: 10,
          },


        });


        
        
const PensionSpecimanSlip = ({ result }) => {

    const tableData = [
        ['1', ' '],
        ['2', ``],
        ['3', ``],

      ];
      
  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.subtitle, {textAlign: 'left'}]}>Enclosures of form No.5. (item 3)</Text>
                <Text style={[style.title, style.ArialBold]}>SPECIMEN SIGNATURE SLIP</Text>
                <AutoText style={[style.paragraph]}>Specimen Signature of {result.employeeName} </AutoText>

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                      </View>
                    ))}
              </View>
              <Text style={[style.paragraph, { marginTop: 10 }]}>Certified that the above specimen signature was taken in my presence.</Text>

              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>


                <View style={[style.solidLine, {marginTop: 60}]} />



                <Text style={[style.subtitle, {textAlign: 'left'}]}>Enclosures of form No.5. (item 4)</Text>

                <Text style={[style.title, style.ArialBold]}>Pensioner's Photograph</Text>


                  {/* Photo Rectangle */}
                  <View style={styles.photoContainer}>
                  <View style={styles.photoRectangle}>
                      <Text style={styles.photoText}>Paste Photo Here</Text>
                  </View>
                  </View>


                  <AutoText style={[styles.paragraph, { marginTop: 10 }]}>Certified that signature and the photographs are those of {result.employeeName}</AutoText>

                  <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>

              </View>

);
};

export default PensionSpecimanSlip;